module.exports = __webpack_public_path__ + "assets/img/desktop.c3135a31.jpg";